
    <form (ngSubmit)="selectCampaign()" [formGroup]="form">
      <div class="ui-g form-group master-data">
        <div class="ui-g-12">
          <p-listbox [disabled]="saveAndListBoxDisabled" [options]="wizardCampaigns" formControlName="campaigns"
                     filter="filter">
          </p-listbox>
        </div>
      </div>
      <div class="text-right">
        <button
          pButton
          type="submit"
          class="k-generic-btn"
          icon="fa fa-save"
          label="{{'promotion.saveAndNext' | translate}}"
          [disabled]="form.controls['campaigns'].value === null || saveAndListBoxDisabled">
        </button>
      </div>
    </form>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/choose-campaign/tab-choose-campaign.component.ts.TabChooseCampaignComponent.html